import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ROLE_RANK = { customer: 1, sales: 2, admin: 3 };

/** Restricts a route to users at or above the given role */
const RoleRoute = ({ minRole = "customer", children }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <p style={{ textAlign: "center", padding: "3rem" }}>Loading...</p>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  const rank = ROLE_RANK[user?.role] || 0;
  if (rank < (ROLE_RANK[minRole] || 0)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RoleRoute;
